export default __webpack_public_path__ + "static/media/enhancement.794cce9c.png";